export const PROF_IMAGE_URL = i => `/static/image/prof-${i}.svg`;
